// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DayChip-module__chip___IxQyM {
  font-family: inherit;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
  padding: 6px 14px;
  font-size: 13px;
  border-radius: 999px;
  border: 1px solid #d4d4d8;
  background: #ffffff;
  color: #3f3f46;
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease, background-color 0.15s ease;
}
.DayChip-module__chip___IxQyM:hover {
  border-color: #18181b;
  color: #18181b;
}

.DayChip-module__chipCompact___xQJEE {
  gap: 5px;
  padding: 5px 11px;
}

.DayChip-module__chipSelected___bpFQP {
  border-color: #18181b;
  background: #18181b;
  color: #ffffff;
}
.DayChip-module__chipSelected___bpFQP:hover {
  color: #ffffff;
}

.DayChip-module__count___CooJ6 {
  font-size: 12px;
  color: #a1a1aa;
}

.DayChip-module__chipSelected___bpFQP .DayChip-module__count___CooJ6 {
  color: #d4d4d8;
}

.DayChip-module__countPill___lygiO {
  padding: 0 6px;
  border-radius: 999px;
  background: #f4f4f5;
  font-size: 12px;
  line-height: 20px;
  color: #52525b;
  font-variant-numeric: tabular-nums;
}

.DayChip-module__chipSelected___bpFQP .DayChip-module__countPill___lygiO {
  background: #3f3f46;
  color: #f4f4f5;
}

.DayChip-module__countPillCompact___tAji5 {
  padding: 0 6px;
  font-size: 12px;
  line-height: 19px;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/DayChip/DayChip.module.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,oBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,kFAAA;AACF;AACE;EACE,qBAAA;EACA,cAAA;AACJ;;AAGA;EACE,QAAA;EACA,iBAAA;AAAF;;AAGA;EACE,qBAAA;EACA,mBAAA;EACA,cAAA;AAAF;AAEE;EACE,cAAA;AAAJ;;AAIA;EACE,eAAA;EACA,cAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kCAAA;AADF;;AAIA;EACE,mBAAA;EACA,cAAA;AADF;;AAIA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;AADF","sourcesContent":[".chip {\n  font-family: inherit;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  white-space: nowrap;\n  padding: 6px 14px;\n  font-size: 13px;\n  border-radius: 999px;\n  border: 1px solid #d4d4d8;\n  background: #ffffff;\n  color: #3f3f46;\n  cursor: pointer;\n  transition: border-color 0.15s ease, color 0.15s ease, background-color 0.15s ease;\n\n  &:hover {\n    border-color: #18181b;\n    color: #18181b;\n  }\n}\n\n.chipCompact {\n  gap: 5px;\n  padding: 5px 11px;\n}\n\n.chipSelected {\n  border-color: #18181b;\n  background: #18181b;\n  color: #ffffff;\n\n  &:hover {\n    color: #ffffff;\n  }\n}\n\n.count {\n  font-size: 12px;\n  color: #a1a1aa;\n}\n\n.chipSelected .count {\n  color: #d4d4d8;\n}\n\n.countPill {\n  padding: 0 6px;\n  border-radius: 999px;\n  background: #f4f4f5;\n  font-size: 12px;\n  line-height: 20px;\n  color: #52525b;\n  font-variant-numeric: tabular-nums;\n}\n\n.chipSelected .countPill {\n  background: #3f3f46;\n  color: #f4f4f5;\n}\n\n.countPillCompact {\n  padding: 0 6px;\n  font-size: 12px;\n  line-height: 19px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chip": `DayChip-module__chip___IxQyM`,
	"chipCompact": `DayChip-module__chipCompact___xQJEE`,
	"chipSelected": `DayChip-module__chipSelected___bpFQP`,
	"count": `DayChip-module__count___CooJ6`,
	"countPill": `DayChip-module__countPill___lygiO`,
	"countPillCompact": `DayChip-module__countPillCompact___tAji5`
};
module.exports = ___CSS_LOADER_EXPORT___;
